(function() {
jQuery(function() {
  if ($("#public_invoice").length > 0) {
    return $('html, body').animate({
      scrollTop: $('#invoice_payment_section').offset().top
    }, 'slow');
  }
});

$(document).on("click", '.show_loader', function(e) {
  var $elem, position;
  $elem = $(e.target);
  position = $elem.offset();
  return $('#spinner').css({
    position: 'absolute',
    top: position.top + 4,
    left: position.left + $elem.width() + 4
  }).show();
});

$(document).ajaxComplete(function() {
  return $('#spinner').hide();
});

$(document).on('click', '.copy-btn', (function(_this) {
  return function(e) {
    var btn, msg, textToCopy, wrap;
    btn = $(e.currentTarget);
    wrap = btn.closest('.copy-wrap');
    textToCopy = btn.data('copy-text');
    msg = wrap.find('.copied-msg');
    return navigator.clipboard.writeText(textToCopy).then(function() {
      msg.stop(true, true).fadeIn(100);
      return setTimeout((function() {
        return msg.fadeOut(100);
      }), 2000);
    })["catch"](function(err) {
      return console.error('Copy failed:', err);
    });
  };
})(this));

}).call(window);
